import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {SharedModule} from './shared/shared.module';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { Interceptor } from '../app/core/services/auth.interceptor';
import {RouterModule} from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { Angular4PaystackModule } from 'angular4-paystack';
import {AutoFocus} from '../app/shared/directive/autofocus.directive';
import { CurrencyLocaleService } from './core/services/currency-locale.service';
import {FeaturesModule} from "./features/features.module";
import { RedirectComponent } from './redirect/redirect.component';
import { ConfigService } from './core/services/config.service';
import { lastValueFrom } from 'rxjs';

// export function initializeApp(appConfig: ConfigService) {
//   return () => appConfig.loadConfig();
// }

export function initializeApp(configService: ConfigService): () => Promise<void> {
  return () => lastValueFrom(configService.loadConfig()).then(() => {
    const loader = document.getElementById('app-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  });

}


@NgModule({
  declarations: [
    AppComponent,
    AutoFocus,
    RedirectComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right'
    }),
    Angular4PaystackModule.forRoot('pk_test_60542cf876252561ac129f72695d3111c36ca0b3'),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ ConfigService ],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS, 
      useClass: Interceptor, 
      multi: true
    },
    { provide: [LOCALE_ID], 
      useValue: 'en-US'
    }, 
    RouterModule, 
    AutoFocus
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
